import React, { useEffect, useState, useRef } from "react";
import Header from "../components/global/Header";
import LeftNavbar from "../components/global/LeftNavbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import FilterProject from "../components/dashboard/FilterProject";
import { useSelector } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import { getAxiosResponse } from "../services/authApiRoutes/APImethods";
import APIUrls from "../services/APIUrls";
import ReactMultiSelect from "../components/global/ReactMultiSelect";
import Constants from "../Constants";
import { useTranslation } from "react-i18next";
import { Breadcrumb } from "../components/dashboard/Breadcrumb";
import { getLoggedInUserRole } from "../services/Util";
import { handleError } from "../services/authApiRoutes/APImethods";
import AppStartupPopups from "../components/AppStartupPopups";
import { AdvancedFilterRemoveIcon, FilterIcon } from "../AppIcons";
import { ConditionalBlock } from "../ConditionalBlock";
import AdvanceFilter from "../components/tasks/AdvanceFilter";

export default function Tasks() {
  const { t } = useTranslation();
  const translate = t;
  const scrollRef = useRef(null);
  const {state} = useLocation();
  const paginationRef = useRef();
  const navigate = useNavigate()
  const [totalRows, setTotalRows] = useState(0);
  const [selectedTaskStatus, setTaskStatus] = useState(state? { label: state.statusLabel, value: state.status } : { label: translate("tasks.tasks.open"), value: "OPEN" });
  const [selectedTypeStatus, setTypeStatus] = useState(state?{ label: state.taskTypeLabel, value: state.tasktypes }:{ label: translate("tasks.tasks.all"), value: Constants.BLANK });
  const [selectedAssignee, setAssignee] = useState(state?{ label: state.assigneeName, value: String(state.assigneeId) } : { label: translate("tasks.tasks.all"), value: "" });
  const [selectedLanguagesString, setLanguageSting] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [displayFilter, toggleDisplayFilter] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [pending, setPending] = useState(true);
  const [sort, setSort] = useState(`&sort=task.dueDate&order=asc`);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortFocus, setsortFocus] = useState('');
  const [openFilter , setOpenfilter] = useState(false)
  const [selectedFilters, setSelectedFilters] = useState({
    Status: { label: translate("tasks.tasks.open"), value: "OPEN" }
  }); 

  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const selectedDepatment = useSelector(
    (departmentSelected) => departmentSelected.select_dropdown
  ).value;
  const tagsRedux = useSelector((updateCampaignTag) => updateCampaignTag.campaign_tag_filter).value;
  const roleArray = getLoggedInUserRole();

  const filterToggle = () => {
    displayFilter ? toggleDisplayFilter(false) : toggleDisplayFilter(true);
  };
  const handleModalFocus = (event) => {
    if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'false') {
      toggleDisplayFilter(false);
      $("#activeId2").trigger("focus");
    }
    if (event.target.ariaLabel === 'Language') {
      event.preventDefault();
      toggleDisplayFilter(false);
      $("#activeId2").trigger("focus");
    }
  }
  
  var departmentString =
    selectedDepatment !== "" ? `&deptId=${selectedDepatment}` : "";
  const followed = useSelector((FollowingSlice) => FollowingSlice.follow).value;
  const filterFunction = () => {
    let isFilterExpanded = ($("#activeId").attr("aria-expanded") === 'true');
    isFilterExpanded ? $("#activeId").attr("aria-expanded", "false")
    : $("#activeId").attr("aria-expanded", "true");

    var element = document.getElementById("filterBtn");
    var element2 = document.getElementById("activeId");
    element.classList.toggle("show-flex");
    element2.classList.toggle("active");
  };
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  
  useEffect(() => {
    if (displayFilter ) {
      $(".local-filter").css("display", "block");
      $("#activeId2").attr("aria-expanded", "true");
    } else {
      $(".local-filter").css("display", "none");
      $("#activeId2").attr("aria-expanded", "false");
    }
  }, [displayFilter]);

  const redirectToTabWithId = (e,projectId,detailTab,tabId) =>{
    if(detailTab === 'overView'){
      e.preventDefault();navigate(`/project/${projectId}`,{state:{tab:detailTab,langCode:tabId}})
    }else{
      e.preventDefault();navigate(`/project/${projectId}`,{state:{tab:detailTab,id:tabId}})
    }
    
  }

  useEffect(() => {
    if (state) {
      const { mine, status, taskTypeLabel, tasktypes, assigneeId, assigneeName, statusLabel } = state;
      let filters = selectedFilters;
      filters.Status = { label: statusLabel, value: status };
      filters.Type = { label: taskTypeLabel, value: tasktypes }; 
      filters["Assigned To"] = { label: assigneeName, value: String(assigneeId) };
      setSelectedFilters(filters);
    }
  }, [state]);

  const getTaskUrl = (task) => {
    var url = "/project";
    var code = ''
    switch (task.type.originalEnum) {
      case "SELECT_WINNING_BID":
        return (
          <button className="button-link"  onClick={(e) => redirectToTabWithId(e,task.project.id,'bids','')}>
            {task.displayName}
          </button>
        );

      case "CONFIGURE_PROJECT_WORKFLOW"  :
        url = `/${task.url.substring(1)}`;
        return (
          <Link  to={url}>
            {task.displayName}
          </Link>
        );
        case "REVIEW_BID_DUE_DATE"  :
          url = `/${task.project.path.substring(1)}`;
          return (
            <Link  to={url}>
              {task.displayName}
            </Link>
          );    
      case "SUBMIT_TM_AND_CLOSE_PROJECT"  :
        url = `/${task.url.substring(1)}`;
        return (
          <Link  to={url}>
            {task.displayName}
          </Link>
        );

      case "CONFIGURE_PROJECT_SOURCE"  :
        url = `/${task.project.path.substring(1)}`;
        return (
          <Link  to={url}>
            {task.displayName}
          </Link>
        );

      case "RESPOND_TO_CUSTOMER_INTERNAL_PROJECT_REQUEST":
        return (
          <button className="button-link"  onClick={(e) => redirectToTabWithId(e,task.project.id,'internalTranslator','')}>
            {task.displayName}
          </button>
        );

      case "RESPOND_TO_MACHINE_TRANSLATION_QUOTE":
        url = `/project/${task.project.id}/machineTranslation`;
        return (
          <Link  to={url}>
            {task.displayName}
          </Link>
        );

      case "RESPOND_TO_VENDOR_CHANGE_ORDER_BID":
        url = `/${task.url.substring(1)}`;
         code = task?.url.split("/").pop()
        return (
          <button className="button-link"  onClick={(e) => redirectToTabWithId(e,task.project.id,'changeOrder',code)}>
            {task.displayName}
          </button>
        );
      case "RESPOND_TO_CUSTOMER_CHANGE_ORDER_REQUEST":
        return (
          <button className="button-link" onClick={(e) => redirectToTabWithId(e,task.project.id,'changeOrder','')}>
            {task.displayName}
          </button>
        );

      case "CUSTOM":
        if(task.project !== ''){
         return (
            <button className="button-link" onClick={(e) => {navigate(`/project/${task.project.id}/tasks/${task.id}`)}}>
              {task.displayName}
            </button>
          );
        }else{
          return (
            <button className="button-link"  onClick={(e) => {navigate(`/campaign/${task.project.id}`)}}>
              {task.displayName}
            </button>
          );
        }

      case "PROJECT_ACCEPT_CANCELLATION":
        return (
          <button className="button-link"  onClick={(e) => redirectToTabWithId(e,task.project.id,'bids','')}>
            {task.displayName}
          </button>
        );

      case "REVIEW_APPROVED_ASSET_NOTES":
        url = `/${task.url.substring(1)}`
        return (
          <Link className="button-link"  to={url}>
            {task.displayName}
          </Link>
        );


      case "REQUEST_BIDS_FOR_PROJECT":
        url = `/project/${task.project.id}`;
        return (
          <Link  to={url}>
            {task.displayName}
          </Link>
        );


      case "REVIEW_PROJECT_ASSETS":
        if(task.language !== ''){
          code = task.language.code
        }else{
          code = task?.url.split("/").pop()
        }
        return (
          <button className="button-link"  onClick={(e) => redirectToTabWithId(e,task.project.id,'overView',code)}>
            {task.displayName}
          </button>
        );

      case "DELIVER_PROJECT_ASSETS":
        if(task.language !== ''){
          code = task.language.code
        }else{
          code = task?.url.split("/").pop()
        }
        return (
          <button className="button-link" onClick={(e) => redirectToTabWithId(e,task.project.id,'overView',code)}>
            {task.displayName}
          </button>
        );

      case "REVISE_PROJECT_ASSETS":
        url = `/${task.url.substring(1)}`;
        if(task.language !== ''){
          code = task.language.code
        }else{
          code = task?.url.split("/").pop()
        }
        return (
          <button className="button-link"  onClick={(e) => redirectToTabWithId(e,task.project.id,'overView',code)}>
            {task.displayName}
          </button>
        );

      case "REVIEW_PROJECT_REQUEST":
        url = `/${task?.url.substring(1)}`;
        return (
          <Link  to={url}>
            {task.displayName}
          </Link>
        );

      case "ASSIGN_USERS_TO_GROUPS":
        url= `/settings/user-management`
        return (
          <Link  to={url}>
            {task.displayName}
          </Link>
        );

      default:
        return "";
    }
  };
  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
        <div role="row" className="no-data-display align-center">
          <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_DATA_FOUND}</p>
          </div>
        </div>
      </div>
    );
  };
  const columns = [
    {
      id: "tasks.name",
      name: translate("tasks.tasks.name"),
      selector: (row) => row.displayName,
      sortable: true,
      cell: (row) => (
        getTaskUrl(row)
      ),
    },
    {
      id: "tasks.type",
      name: translate("tasks.tasks.type"),
      selector: (row) => row.taskCategoryDisplay,
      sortable: true,

    },
    {
      id: "tasks.project.name",
      name: translate("tasks.tasks.project"),
      selector: (row) => row.alertCount,
      sortable: true,
      cell: (row) => (
        <span>
          {row.project !== '' ?
          row.userGroup.name
            ? row.project.name + "(" + row.userGroup.name + ")"
            : row.project.name : row.projectRequest.name ?
            row.projectRequest.name + "(" + row.userGroup.name + ")" : ''}
        </span>
      ),
    },
    {
      id: "task.sorted_task_assignee_user_id",
      selector: (row) => row?.type?.originalEnum === Constants.CUSTOM && row.assigneeVendor ? `${row.assigneeVendor.name} (Vendor)` : row.assigneeUserName,
      name: translate("tasks.tasks.assigned_to"),
      sortable: true,
      cell: (row) => row?.type?.originalEnum === Constants.CUSTOM && row.assigneeVendor ? `${row.assigneeVendor.name} (Vendor)` : row.assigneeUserName,
    },
    {
      id: "task.targetLanguage",
      name: translate("tasks.tasks.language"),
      selector: (row) => row.targetLanguage,
      sortable: true,
      cell: (row) => row.language.displayName,
    },
    {
      id: "task.status",
      name: translate("tasks.tasks.status"),
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => {
        if(row.status.code === "closed"){
          return translate("tasks.tasks.completed");
        }else{
          return translate("tasks.tasks." + row.status.code);
        }
        
      },
    },
    {
      id: "task.dueDate",
      name: translate("tasks.tasks.due_date"),
      selector: (row) => row.dueDate,
      cell: (row) => {
        return row.dueDate.date
      },
    },
  ];
  const handleSort = async (column, sortDirection) => {
    var order = sortDirection.toLowerCase();
    var sortedColumn = column.id;
    var sortedString = `&order=${order}&sort=${sortedColumn}`;
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']").attr({
      "aria-label": column.name,
      "aria-sort":
        order === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING,
    });
    setSort(sortedString);
    setsortFocus(column.id);
  };

  $(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true");
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
    $(".rdt_Table").attr("aria-label","Tasks"); 
    $('.rdt_Table input').parent().attr("role","cell")
   })

  const handlePageChange = (paging) => {
    setPending(true);
    setCurrentPage(paging);
    if ($('#pagination-last-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-previous-page').attr('id');
    } else if ($('#pagination-first-page').attr('aria-disabled')==="true") {
      paginationRef.current = $('#pagination-next-page').attr('id');
    } else {
      paginationRef.current = document.activeElement.id;
    }
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  const onApplyFilters = (filterData) => {
    setTaskStatus(filterData[translate("tasks.tasks.status")]);
    setTypeStatus(filterData[translate("tasks.tasks.type")]);
    setAssignee(filterData[translate("task_campaign.assigned_to")]);
    const state = {
      status: filterData[translate("tasks.tasks.status")].value,
      statusLabel: filterData[translate("tasks.tasks.status")].label,
      taskTypeLabel: filterData[translate("tasks.tasks.type")].label,
      tasktypes: filterData[translate("tasks.tasks.type")].value,
      mine: filterData[translate("task_campaign.assigned_to")].label === "Me",
      assigneeId: filterData[translate("task_campaign.assigned_to")].value,
      assigneeName: filterData[translate("task_campaign.assigned_to")].label
    };
    setLanguageSting(filterData[translate("tasks.tasks.languages")]);
    setSelectedFilters(filterData);
    navigate('', {state}, {replace: true});
  }

  const fetchTaskData = async (page) => {
    const selectedTags = tagsRedux.length > 0 ? tagsRedux.map(tag => `&tag=${tag.value}`).join('') : Constants.BLANK;
    
    const reviewerType = roleArray.includes('ROLE_CUSTOMER_REVIEWER') && roleArray.length === 1 
      ? "&mine=true&type=CUSTOM&type=APPROVE_LANGUAGE_OR_REQUEST_REVISION&type=APPROVE_LANGUAGE_OR_REQUEST_REVISIONS&type=REVIEW_PROJECT_ASSETS" 
      : Constants.BLANK;
  
    const selectedLanguageCodes = selectedLanguagesString.length > 0 
      ? selectedLanguagesString.map(lang => `&langs=${lang.value}`).join('') 
      : Constants.BLANK;
  
    const selectedTaskTypes = selectedTypeStatus && selectedTypeStatus.value && selectedTypeStatus.value.length > 0 
      ? selectedTypeStatus.value.map(value => `&type=${value}`).join('') 
      : Constants.BLANK;
  
    const assigneeId = selectedAssignee && selectedAssignee.value ? selectedAssignee.value : Constants.BLANK;
  
    const filterUrl = window.location.search !== Constants.BLANK 
      ? window.location.search 
      : `?onlyFollowed=${followed}&status=${selectedTaskStatus.value}${selectedTaskTypes}&assigneeId=${assigneeId}${selectedLanguageCodes}&page=${page}&pageSize=${perPage}${sort}${departmentString}${selectedTags}${reviewerType}`;
  
    try {
      const res = await getAxiosResponse(APIUrls.ALL_TASKS + filterUrl);
      if (res.data !== "") {
        setTasks(res.data.data.result);
        setTotalRows(res.data.data.resultCount);
        setTimeout(() => {
          if (sortFocus) {
            $(".rdt_TableCol_Sortable[data-column-id='" + sortFocus + "']").trigger('focus');
            setsortFocus('');
          } else if (paginationRef.current) {
            $('#' + paginationRef.current).trigger('focus');
            paginationRef.current = '';
          }
        }, 300);
      } else {
        setTasks([]);
      }
    } catch (err) {
      handleError(err);
    }
    setPending(false);
  };

  useEffect(() => {
    fetchTaskData(currentPage);
  }, [ currentPage, sort, followed, selectedDepatment, selectedTaskStatus, selectedTypeStatus, selectedAssignee, selectedLanguagesString, tagsRedux, perPage ]);
  
  const crumbs = [
    {label:'Tasks', url:''},
  ];

  useEffect(()=>{
    $('.lastdisable').trigger('focus')
  },[])

 const showRightModel = (state) => {
    setTimeout(() => {
      $("#close-right-popup").trigger("focus");
    }, 300);

    if(state === false){
      if(openFilter){
        document.body.classList.remove("modal-open");
        setOpenfilter(false)
        $("#project-filters").trigger("focus");
      }else{
        setOpenfilter(true)
        document.body.classList.add("modal-open");
      }
    }
    document.body.classList.add("modal-open");
  };

  const closeRightModal = () =>{
    showRightModel(false)
    setOpenfilter(false)
    document.body.classList.remove("modal-open");
  }

  const removeFilter = (label) => {
    let stateCopy = { ...state };
    if(label === Constants.STATUS) {
      stateCopy.status = Constants.BLANK ;
      stateCopy.statusLabel = translate("tasks.tasks.select");
      setTaskStatus({ label: translate("tasks.tasks.select"), value: Constants.BLANK });
      setSelectedFilters({...selectedFilters, Status: { label: translate("tasks.tasks.select"), value: Constants.BLANK }});
    }
    if(label === Constants.TYPE) {
      stateCopy.tasktypes = Constants.BLANK;
      stateCopy.taskTypeLabel = translate("tasks.tasks.select");
      setTypeStatus(Constants.BLANK);
      setSelectedFilters({...selectedFilters, Type: Constants.BLANK});
    }
    if(label === Constants.ASSIGNED_TO) {
      stateCopy.assigneeId = Constants.BLANK;
      stateCopy.assigneeName = translate("tasks.tasks.select");
      setAssignee(Constants.BLANK);
      setSelectedFilters({...selectedFilters, "Assigned To": Constants.BLANK});
    }
    if(label === Constants.LANGUAGES) {
      setLanguageSting([]);
      setSelectedFilters({...selectedFilters, Languages: Constants.BLANK});
    }
    navigate('', {state: stateCopy}, {replace: true});
  }

  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap campaign-section">
            <Breadcrumb crumbs={ crumbs } />
            <div>&nbsp;</div>
            <FilterProject filter="tasks" funct={showRightModel}/>
            <AppStartupPopups/>
            <div className="wrap-data listing-wrap-data">
              <div className="listing-tab-block flex"></div>
              <div className="white-bg">
                <div className="campaign_details-task campaign-form task-page-form">
                  <div className="projects-heading campaign-name">
                    <h3>{translate("tasks.tasks.tasks")}</h3>
                  </div>
                </div>

                <div className="campaign-hedaing flex justify-center">
                  <ul className="selected-data flex">
                    {Object.entries(selectedFilters).map(([label, value]) => {
                      let values = Array.isArray(value) ? value : (value ? [value] : []);
                      let labels = [];
                      if(values.length !== 0) {
                        labels = values
                        .filter(item => item.label?.length !== 0 && item.label !== "" && item.label !== Constants.SELECT && item.label.toLowerCase() !== Constants.ALL)
                        .map(item => item.label);
                      }

                      return labels.length > 0 && (
                        <li key={label}>
                          <button onClick={(e) => {removeFilter(label)}}>
                            <p aria-label={`Remove ${label} : ${labels.join(', ')}`} >
                              <small>{label} : </small> {labels.join(', ')}
                            </p>
                            <span>
                              {AdvancedFilterRemoveIcon}
                            </span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                <div className="datatable-block">
                  <DataTable
                    keyField="id"
                    columns={columns}
                    // selectableRows
                    defaultSortFieldId="project.name"
                    responsive
                    striped
                    selectableRowsHighlight={true}
                    // onSelectedRowsChange={handleChange}
                    pagination
                    onSort={handleSort}
                    pointerOnHover={true}
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationRowsPerPageOptions={[10, 20, 40, 50, 100, 200]}
                    onChangePage={handlePageChange}
                    noDataComponent={noDataFoundComponent()}
                    data={tasks}
                    progressPending={pending}
                  />
                </div>
              </div>
            </div>
            <ConditionalBlock condition={openFilter}>
              <AdvanceFilter funct={showRightModel} department={selectedDepatment} onApply={onApplyFilters} taskStatus={selectedTaskStatus} typeStatus={selectedTypeStatus} assignee={selectedAssignee} languages={selectedLanguagesString}/>
            </ConditionalBlock>
          </div>
          <div className="overlay" onClick={closeRightModal}></div>
        </section>
      </div>
    </div>
  );
}
